import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { BotComparison } from '../components/BotComparison';
import { TheirAiOursSection } from '../components/TheirAiOursSection';
import { SystemMapSection } from '../components/SystemMapSection';
import { LeakSection } from '../components/LeakSection';
import { WorkingExamples } from '../components/WorkingExamples';
import { WhoItIsFor } from '../components/WhoItIsFor';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function Why() {
  usePageTitle('Why | You were right to turn it off | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Why" title="You were right to turn it off." body="Most AI tools sold to agents deserve it. Here is the difference between what you tried and what we run." data-id="element-584" data-mp="9004c4reocd2" />
      <BotComparison data-id="element-585" data-mp="wrp2w2utlx2g" />
      <TheirAiOursSection data-id="element-586" data-mp="wr5jsitfp2mu" />
      <SystemMapSection surface="ink-900" data-id="element-587" data-mp="wqvu6wcawxho" />
      <LeakSection data-id="element-588" data-mp="3cqpkox8a25jm" />
      <WorkingExamples data-id="element-589" data-mp="3cq62dfeptf52" />
      <WhoItIsFor data-id="element-590" data-mp="3crqzncsezc6m" />
      <NextStepPanel title="So who is Viridia to run this for you?" buttonLabel="Why teams hire Viridia" to="/why-viridia" data-id="element-591" data-mp="3cr7n6blj9fzz" />
    </>;
}